import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../client";

const BASE_URL = "identity/user";

export const getUsers = createAsyncThunk(
  "User/list",
  async () => (await api.get(BASE_URL)).data,
);

export const getUser = createAsyncThunk(
  "User",
  async (id) => (await api.get(`${BASE_URL}/${id}`)).data,
);

export const saveUser = createAsyncThunk(
  "User/save",
  async (user) => (await api.post(BASE_URL, user)).data,
);

export const updateUser = createAsyncThunk(
  "User/update",
  async (user) => (await api.put(`${BASE_URL}/${user.id}`, user)).data,
);

export const deleteUser = createAsyncThunk(
  "User/delete",
  async (id) => (await api.delete(`${BASE_URL}/${id}`)).data,
);

const addCases = (builder, thunk, onFulfilled, clearMessage = false) =>
  builder
    .addCase(thunk.pending, (state) => {
      state.isLoading = true;
      if (clearMessage) state.message = "";
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.isLoading = false;
      onFulfilled(state, action);
    })
    .addCase(thunk.rejected, (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
    });

const initialState = {
  list: [],
  user: null,
  isLoading: false,
  message: null,
  lastFetch: null,
};

const slice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCases(builder, getUsers, (state, action) => {
      state.list = action.payload.data;
      state.lastFetch = Date.now();
    });
    addCases(builder, getUser, (state, action) => {
      state.user = action.payload.data;
    });
    addCases(
      builder,
      saveUser,
      (state, action) => {
        state.message = action.payload.message;
      },
      true,
    );
    addCases(
      builder,
      updateUser,
      (state, action) => {
        state.message = action.payload.message;
      },
      true,
    );
    addCases(
      builder,
      deleteUser,
      (state, action) => {
        state.message = action.payload.message;
      },
      true,
    );
  },
});

export default slice.reducer;
